import { useExpenseSummary } from './use-expenses';
import { useMemo } from 'react';

export interface ExpenseBadge {
  text: string;
  variant: 'default' | 'destructive' | 'warning';
  count: number;
}

export function useExpenseBadges() {
  const { data: summary, isLoading } = useExpenseSummary();
  
  return useMemo(() => {
    if (isLoading || !summary) {
      return null;
    }

    // Prioridade: vencidas > em aberto > nenhum badge
    if (summary.overdue.count > 0) {
      return {
        text: `${summary.overdue.count} vencida${summary.overdue.count > 1 ? 's' : ''}`,
        variant: 'destructive' as const,
        count: summary.overdue.count,
      };
    }

    if (summary.pending.count > 0) {
      return {
        text: `${summary.pending.count} em aberto`,
        variant: 'warning' as const,
        count: summary.pending.count,
      };
    }

    return null;
  }, [summary, isLoading]);
}
